// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__hDDB3","rotation":"Loader_rotation__5p-vK"};